// removed by extract-text-webpack-plugin
module.exports = {"timer":"timer__2vE2-","timerText":"timerText__1rBlo","scramble":"scramble__1XkpL","ready":"ready__1Shda","stopped":"stopped__Q5Vqb","handOnTimer":"handOnTimer__fhyLb"};


//////////////////
// WEBPACK FOOTER
// ./components/TimerDisplay.css
// module id = mFW+
// module chunks = 2